import type { TextStyle } from 'react-native';

import {
    getIndeedApplyButtonText,
    getInterviewNowButtonText,
    useInterviewNow,
} from './useInterviewNow';
import { type ButtonVariant, Video } from '../../../../../../mads';
import { useI18n } from '../../../../../../shared/I18n';
import { logScreenViewWithExtraParams } from '../../../../../../shared/native-modules/tare/logScreenViewWithExtraParams';
import { logTapButtonWithExtraParams } from '../../../../../../shared/native-modules/tare/logTapButtonWithExtraParams';
import { useViewjobOneGraphModel } from '../../../../context/ViewJobDataContext';

import {
    ActionType,
    log as logINowRequest,
    PageId,
} from '@indeed/signals-schema/com/indeed/signals/schema/interviewOnDemand/iodUserAction';

export type GetInterviewNowIndeedApplyButtonFn = (isSecondaryApplyButton?: boolean) => {
    buttonText?: string;
    isSecondaryApplyButton?: boolean;
    forceEnabled?: boolean;
    variant?: ButtonVariant;
    iconBefore?: React.ReactElement;
    buttonTextSx?: TextStyle;
    onClick?: () => void;
    onFirstImpression?: () => void;
};

export const tags = ['viewjob', 'interview-now'];

export const useGetInterviewNowIndeedApplyButtonProps = (): GetInterviewNowIndeedApplyButtonFn => {
    const interviewNowModel = useInterviewNow();
    const i18n = useI18n();
    const jobKey = useViewjobOneGraphModel()?.job?.jobKey;
    const pageId = { PageId: PageId.VIEWJOB };

    return (isSecondaryApplyButton?: boolean) => {
        if (!interviewNowModel) {
            return {};
        }

        return isSecondaryApplyButton
            ? {
                  buttonText: getIndeedApplyButtonText(i18n),
                  isSecondaryApplyButton,
                  forceEnabled: false,
                  variant: 'utility' as ButtonVariant,
                  iconBefore: undefined,
                  buttonTextSx: undefined,
                  onClick: () => {
                      logTapButtonWithExtraParams(
                          'rn-view-job-interview-now-secondary-cta-pressed',
                          'interview-now-secondary-cta',
                          tags,
                          { jobKey: jobKey ?? '' },
                      ).catch(console.error);
                      logINowRequest({
                          actionType: { ActionType: ActionType.SECONDARY_CTA_CLICKED },
                          pageId,
                      });
                  },
                  onFirstImpression: () => {
                      logScreenViewWithExtraParams(
                          'rn-view-job-interview-now-secondary-cta-seen',
                          tags,
                          { jobKey: jobKey ?? '' },
                      ).catch(console.error);
                      logINowRequest({
                          actionType: { ActionType: ActionType.SECONDARY_CTA_SEEN },
                          pageId,
                      });
                  },
              }
            : {
                  buttonText: getInterviewNowButtonText(i18n),
                  isSecondaryApplyButton,
                  forceEnabled: true,
                  variant: 'primary' as ButtonVariant,
                  iconBefore: <Video color="rgb(255, 255, 255)" />,
                  buttonTextSx: { marginLeft: 4 },
                  onClick: () => {
                      logTapButtonWithExtraParams(
                          'rn-view-job-interview-now-primary-cta-pressed',
                          'interview-now-primary-cta',
                          tags,
                          { jobKey: jobKey ?? '' },
                      ).catch(console.error);
                      logINowRequest({
                          actionType: { ActionType: ActionType.PRIMARY_CTA_CLICKED },
                          pageId,
                      });
                  },
                  onFirstImpression: () => {
                      logScreenViewWithExtraParams(
                          'rn-view-job-interview-now-primary-cta-seen',
                          tags,
                          { jobKey: jobKey ?? '' },
                      ).catch(console.error);
                      logINowRequest({
                          actionType: { ActionType: ActionType.PRIMARY_CTA_SEEN },
                          pageId,
                      });
                  },
              };
    };
};
